import gql from 'graphql-tag';
import { questionFieldsFragment } from '@graphql/admin/fragments';

export const updateQuestionMutation = gql`
  mutation UpdateQuestion($id: ID!, $input: UpdateQuestionInput!) {
    updateQuestion(id: $id, input: $input) {
      ...AdminQuestionFields
    }
  }

  ${questionFieldsFragment}
`;